var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckedSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4343 11.7314L0.234305 6.53136C-0.0781016 6.21895 -0.0781016 5.71242 0.234305 5.39998L1.36565 4.26861C1.67805 3.95617 2.18462 3.95617 2.49702 4.26861L5.99999 7.77154L13.503 0.268606C13.8154 -0.0437998 14.3219 -0.0437998 14.6343 0.268606L15.7657 1.39998C16.0781 1.71239 16.0781 2.21892 15.7657 2.53136L6.56568 11.7314C6.25324 12.0438 5.74671 12.0438 5.4343 11.7314Z",
    fill: "#27509F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedSave);
export default __webpack_public_path__ + "static/media/checked-save.e9ccda758fd440ba146dca289a0c09dc.svg";
export { ForwardRef as ReactComponent };